'use client';

import { DotsVertical, Edit02, Folder, Trash02 } from '@ethsign/icons';
import { Dropdown, Input, useToast } from '@ethsign/ui';
import { useEffect, useRef, useState } from 'react';

import { MenuItem } from '@/components';

interface Props {
  id: string;
  isActive: boolean;
  name: string;
  onClick: (id: string) => void;
  onEdit: (item: { name: string; id: string }) => void;
  onDelete: (id: string) => void;
  isEditing?: boolean;
  count: number;
}
export function FolderItem(props: Props) {
  const { id, isActive, name, onClick, onEdit, onDelete, count } = props;
  const [isEditing, setIsEditing] = useState(props.isEditing);
  const [tempName, setTempName] = useState(name);
  const { toast } = useToast();
  const inputRef = useRef<any>(null);
  useEffect(() => {
    setTempName(name);
  }, [name]);
  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  return (
    <div key={id} onClick={() => onClick(id)}>
      <MenuItem
        isFolder
        icon={<Folder size={16}></Folder>}
        isActive={isActive}
        rightIcon={
          <Dropdown
            items={[
              {
                icon: <Edit02 size={16} color="#101828"></Edit02>,
                label: 'Rename',
                onClick: () => {
                  setIsEditing(true);
                }
              },
              {
                icon: <Trash02 size={16} color="#101828"></Trash02>,
                label: 'Delete',
                onClick: () => {
                  onDelete(id);
                }
              }
            ]}
          >
            <DotsVertical
              color="#344054"
              size={16}
              onClick={(e) => {
                e.stopPropagation();
              }}
            ></DotsVertical>
          </Dropdown>
        }
      >
        {isEditing ? (
          <Input
            ref={inputRef}
            className="w-[130px] font-normal text-sm"
            placeholder={name}
            defaultValue={name}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onBlur={(e) => {
              if (e.target.value) {
                setIsEditing(false);
                setTempName(e.target.value);
                onEdit({ name: e.target.value, id });
              } else {
                inputRef.current.focus();
                toast({ title: 'Error', description: 'Folder name cannot be empty', variant: 'error' });
              }
            }}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                if (e.target.value) {
                  setIsEditing(false);
                  setTempName(e.target.value);
                  onEdit({ name: e.target.value, id });
                } else {
                  inputRef.current.focus();
                  toast({ title: 'Error', description: 'Folder name cannot be empty', variant: 'error' });
                }
              }
            }}
          ></Input>
        ) : (
          <div title={name} className="flex flex-row items-center flex-1">
            <span className="max-w-[110px]  truncate inline-block align-middle ">{tempName}</span>
            <span
              title={count + ''}
              className={`inline-block text-gray-500 p-1 ml-2 rounded-sm align-middle bg-primary-${
                isActive ? '100' : '50'
              } `}
            >
              {count > 99 ? '99+' : count}
            </span>
          </div>
        )}
      </MenuItem>
    </div>
  );
}
